export default "__VITE_ASSET__f3bb5fc2__"